import { render, staticRenderFns } from "./DialogView.vue?vue&type=template&id=6d1eade4&scoped=true&"
import script from "./DialogView.vue?vue&type=script&lang=js&"
export * from "./DialogView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=6d1eade4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1eade4",
  null
  
)

export default component.exports